import { FlagReason } from "@/lib/interaction-types";

interface FlagIndicatorDisplayProps {
  flagReasons: FlagReason[] | null;
  filterTypes?: Array<FlagReason["type"]>;
}

export function FlagIndicatorDisplay({ flagReasons, filterTypes }: FlagIndicatorDisplayProps) {
  if (!flagReasons || flagReasons.length === 0) return null;

  const reasons = filterTypes
    ? flagReasons.filter((r) => filterTypes.includes(r.type))
    : flagReasons;

  if (reasons.length === 0) return null;

  return (
    <div className="space-y-1.5" data-testid="interaction-flag-indicator">
      {reasons.map((reason, i) => {
        if (reason.type === "long_note") {
          return (
            <div key={i} className="flex items-center gap-1.5 text-xs text-muted-foreground">
              <span className="font-medium text-foreground">Long Note</span>
              {reason.charCount != null && (
                <span>{reason.charCount.toLocaleString()} characters</span>
              )}
            </div>
          );
        }

        if (reason.type === "keyword") {
          return (
            <div key={i} className="flex items-center gap-1.5 text-xs text-muted-foreground">
              <span className="font-medium text-foreground">Keyword Match:</span>
              {reason.matches && reason.matches.length > 0 && (
                <span>{reason.matches.join(", ")}</span>
              )}
            </div>
          );
        }

        return null;
      })}
    </div>
  );
}
